import { GetDashboard, GetSummary, GetBalances, GetWalletOverview } from "../../services/metrics";

export const getSummary = (context, data) => {
    context.commit("updateLoader", { fetchSummary: true });
    GetSummary(data)
        .then(res => {
            context.commit("fetchSummary", res.data.data);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            // stop loaders
            context.commit("updateLoader", { fetchSummary: false });
        });
};

export const getDashboard = (context, data = {}) => {
    context.commit("updateLoader", { getDashboard: true });
    return new Promise((resolve, reject) => {
        GetDashboard(data)
            .then(res => {
                const result = res.data.data
                context.commit("getDashboard", result);
                resolve(result);
            })
            .catch(err => {
                console.log(err);
                reject(err);
            })
            .finally(() => {
                // stop loaders
                context.commit("updateLoader", { getDashboard: false });
            });
    });
};

export const getBalances = (context) => {
    context.commit("updateLoader", { getBalances: true });
    return new Promise((resolve, reject) => {
        GetBalances()
            .then(res => {
                const result = res.data.data
                context.commit("getBalances", result);
                resolve(result);
            })
            .catch(err => {
                console.log(err);
                reject(err);
            })
            .finally(() => {
                // stop loaders
                context.commit("updateLoader", { getBalances: false });
            });
    });
};


export const getWalletOverview = (context) => {
    context.commit("updateLoader", { getWalletOverview: true });
    return new Promise((resolve, reject) => {
        GetWalletOverview()
            .then(res => {
                const result = res.data.data
                context.commit("setWalletOverview", result);
                resolve(result);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                // stop loaders
                context.commit("updateLoader", { getWalletOverview: false });
            });
    });
};

const MetricsAction = {
    getSummary,
    getDashboard,
    getBalances,
    getWalletOverview
};

export default MetricsAction;